module.exports = __webpack_public_path__ + "media/images/page/scene01-7461052ef380ea7a94a17de8099f440c.jpg";